<div class="index-back" id="index-back" [@enterAnimation]="animateState"></div>

<div class="container backgroundMain leftNav">

  <app-top-navigation></app-top-navigation>

  <div class="text-center" style="margin: 2%;" *ngIf="state.operating">
    <app-loader></app-loader>
  </div>
  <!-- small screen display only -->
  <div class="mobileFraudList">
    <ul class="nav flex-column" id="fraud-sideMenu">
      <div *ngFor="let item of fraudTypes">
        <li class="nav-item parent {{currentLang == 'en' ? 'eng' : ''}} ">
          <a class="nav-link parent-link " [routerLink]="['/pages/fraud/fraudDetails/', item.id]">
            {{currentLang == 'ar' ? item.title : item.title_en}}
            <img class="nav-item-icon svg" [src]="getImage(item.image)">
          </a>
        </li>
      </div>
    </ul>
  </div>
  <!-- large screen animation -->
  <div class="stage" style="opacity: 1;" *ngIf="state.loaded">
    <div class="most-important" id="mostImportant" style="left: 330px; opacity: 1;">
      <span *ngIf="currentLang == 'ar'" class="title">
        <span style="padding-right: 17px;">{{'importantFraudCases'|translate}}</span>
        <div style="width: 22%;position: unset;float: left;margin-bottom: 2%;">
          <a (click)="changeSlider('next')"><i class="fas fa-angle-right fa-2x"
              style="margin-left: 5%;color:#fff;"></i></a>
          <a (click)="changeSlider('back')"><i class="fas fa-angle-left fa-2x"
              style="margin-left: 15%;color:#fff;"></i></a>
          <!-- <span *ngIf="currentLang == 'en'"> {{'importantFraudCases'|translate}}</span> -->
        </div>
      </span>
      <span *ngIf="currentLang == 'en'" class="title" style="text-align: left;text-indent: 30px;">
        <div style="float: right;width: 24%;">
          <a (click)="changeSlider('back')"><i class="fas fa-angle-left fa-2x"
              style="margin-left: 15%;color:#fff;"></i></a>
          <a (click)="changeSlider('next')"><i class="fas fa-angle-right fa-2x"
              style="margin-left: 5%;color:#fff;"></i></a>

        </div>
        <div style="margin-left: 85px;">{{'importantFraudCases'|translate}}</div>


      </span>
      <div class="slider-most-important slick-initialized slick-slider"
        [ngStyle]="{'padding-left':innerWidth >= 769  ? '88px' : '0' }">
        <div class="row" style="width: 100%;" *ngFor="let item of newSubFraudCategory; let i = index"
          [@enterAnimation]="sliderState">
          <div *ngIf="currentSlider === 'slider'+i" style="width: 100%;">
            <div class="col-md-1 slider-info-icon">
              <img src="../../../assets/img/png-icon/icon-Shape.png" />
            </div>
            <div [ngStyle]="{'text-align':currentLang == 'ar'  ? 'right' : 'left' }" class="col-md-11 slider-info-desc">
              <a *ngIf="currentLang =='ar'">{{item.title}}</a>
              <a style="padding-left: 8px;right: 0.5rem;" *ngIf="currentLang =='en'">{{item.title_en}} </a>
              <div class="comment " [innerHTML]="currentLang =='ar' ?item.description : item.description_en"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="rect-mobail">
      <div class="rect-details" id="rect-details" style="width: 470px; opacity: 1;">
        <div class="item" id="itemDetail" style="opacity: 1;">
          <div class="det-icon" style="opacity: 1; text-align: center;" [@enterAnimation]="fraudItemImageState"><img
              id="itemDetailImage" style="float: right;width: 60px;"
              src="{{urls.getStorageUrl() + '/' + getFarudTypesImage(currentFraudType.image)}}" alt="">
          </div>
          <div class="text">
            <h3 id="itemDetailTitle" style="opacity: 1;" [@fraudItemTitleState]="fraudItemTitleState">
              {{currentLang==='ar' ? currentFraudType.title : currentFraudType.title_en}}</h3>
            <div id="more" class="itemDetailDescription" [@fraudItemDescriptionState]="fraudItemDescriptionState"
              [innerHTML]="currentLang==='ar' ? currentFraudType.description : currentFraudType.description_en">
            </div>
          </div>
        </div>
      </div>
      <div class="rect rect1" id="rect1"
        style="top: 116px; left: 215px; opacity: 1; transform: matrix(-0.7071, -0.7071, 0.7071, -0.7071, 0, 0);">
        <div class="inner">
        </div>
      </div>

      <div class="rect rect2 clickable {{currentFraudIndex === 0 ? 'selected' : ''}}" id="rect2"
        style="top: 99px; left: 129px; opacity: 1;" (click)="fraudTypesClick(0)">
        <div class="inner">
          <img style="float: right;" src="{{urls.getStorageUrl() + '/' + fraudTypesIcons[0]}}" alt="">
        </div>
      </div>
      <div class="rect rect3 clickable {{currentFraudIndex === 1 ? 'selected' : ''}}" id="rect3"
        style="top: 227px; left: 129px; opacity: 1;" (click)="fraudTypesClick(1)">
        <div class="inner">
          <img style="float: right;" src="{{urls.getStorageUrl() + '/' + fraudTypesIcons[1]}}" alt="">
        </div>
      </div>
      <div class="rect rect4 clickable {{currentFraudIndex === 2 ? 'selected' : ''}}" id="rect4"
        style="top: 292px; left: 194px; opacity: 1;" (click)="fraudTypesClick(2)">
        <div class="inner">
          <img style="float: right;" src="{{urls.getStorageUrl() + '/' + fraudTypesIcons[2]}}" alt="">
        </div>
      </div>
      <div class="rect rect5 clickable {{currentFraudIndex === 3 ? 'selected' : ''}}" id="rect5"
        style="top: 357px; left: 260px; opacity: 1;" (click)="fraudTypesClick(3)">
        <div class="inner">
          <img style="float: right;" src="{{urls.getStorageUrl() + '/' + fraudTypesIcons[3]}}" alt="">
        </div>
      </div>
      <div class="rect rect6 clickable {{currentFraudIndex === 4 ? 'selected' : ''}}" id="rect6"
        style="top: 423px; left: 194px; opacity: 1;" (click)="fraudTypesClick(4)">
        <div class="inner">
          <img style="float: right;" src="{{urls.getStorageUrl() + '/' + fraudTypesIcons[4]}}" alt="">
        </div>
      </div>
      <!-- <div id="scamUrl" class="url" style="clip: rect(0px, 180px, 145px, 0px); opacity: 1;">
        ​&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;scam.sa</div> -->
      <div class="emblem">
        <img src="../../../assets/img/images/ShapeLogo.svg" class="logo" id="logo" alt=""
          style="opacity: 1; transform: translate3d(0px, 0px, 0px);">
        <div class="logoTxt">
          <img src="../../../assets/img/images/Arabic.svg" class="ARlogo" id="ARlogo" alt=""
            style="opacity: 1; transform: matrix(1, 0, 0, 1, 0, 0);">
          <img src="../../../assets/img/images/English.svg" class="ENlogo" id="ENlogo" alt="" style="opacity: 1;">
        </div>
      </div>
    </div>
  </div>
</div>

<div class="row">
  <div class="link-boot">
    <a [routerLink]="['/pages/fraud/VictimToScam']" routerLinkActive="router-link-active" title="">
      {{'fraudQuestion'|translate}}
      <img src="../../../assets/img/png-icon/icon17.png" class="fallback-png icon" alt="">
      {{'pressHere'|translate}}</a>
  </div>
</div>
<!-- mobile view only display subfraud categories -->
<div class="mobilesubFraud" [ngStyle]="{'margin-top':currentLang == 'ar'  ? '0' : '50px' }">
  <ngu-carousel #myCarousel [inputs]="carouselOne" [dataSource]="newSubFraudCategory" style="width: 100%;">
    <div *nguCarouselDef="let item;let j = index" class="item">
      <div class="tile2 type-item">
        <!-- ar -->
        <div class="row">
          <div *ngIf="currentLang==='ar'" class=" col-3  imgAr" style="line-height: 10;">
            <img src="../../../assets/img/png-icon/ShapeLogo.png" class="subFraudIcon" />
          </div>
          <div class=" col-9 carouselInfo2 " [ngStyle]="{'text-align':currentLang == 'ar'  ? 'right' : 'left' }">
            <div class="title">
              <div class="headerTitle">{{'importantFraudCases'|translate}}</div>
              <p>{{ currentLang == 'ar' ? item.title : item.title_en}}</p>
            </div>
            <div id="moreExp" [innerHTML]="currentLang == 'ar' ? item.description : item.description_en"></div>
          </div>
          <div *ngIf="currentLang==='en'" class=" col-3  imgAr" style="line-height: 10;">
            <img src="../../../assets/img/png-icon/ShapeLogo.png" class="subFraudIcon" />
          </div>
        </div>
      </div>
    </div>
    <ul class="myPoint" NguCarouselPoint>
      <li *ngFor="let i of myCarousel.pointNumbers; let i = index" [class.active]="i==myCarousel.activePoint"
        (click)="myCarousel.moveTo(i)"></li>
    </ul>
  </ngu-carousel>
</div>
<!--  -->
<div class="row thief-video">
  <div *ngIf="videoSection.length > 0" class="content">
    <h1 *ngIf="currentLang==='ar'">{{videoSection[0].title_video}}</h1>
    <h1 *ngIf="currentLang==='en'">{{videoSection[0].title_video_en}}</h1>
    <div>
      <div *ngIf="currentLang==='ar'" [innerHTML]=" videoSection[0].description_video"></div>
      <div *ngIf="currentLang==='en'" [innerHTML]=" videoSection[0].description_video_en"></div>
      <a href="https://www.youtube.com/embed/2nwY9pvyhUg">
        {{'pressHere'|translate}}
      </a>
    </div>

    <a class="play-btn" data-toggle="modal" data-target="#exampleModalCenter"><i class="far fa-play-circle"></i></a>
  </div>

  <!-- Modal -->
  <div class="modal fade" id="exampleModalCenter" tabindex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle"
    aria-hidden="true">
    <div class="modal-dialog modal-lg modal-dialog-centered" role="document">
      <div class="modal-content" style="background: transparent;border: none;">
        <div *ngIf="videoSection.length > 0" class="modal-body" style="padding: 0px;">
          <!-- <iframe width="100%" height="auto" src="{{videoSection[0].youtube}}">
          </iframe> -->
          <!-- <iframe *ngIf="videoSection[0]?.youtube" width="100%" height="500px;" style="border: 0px;"
            [src]="videoSection[0].youtube">
          </iframe> -->
          <!-- <iframe [src]="safeSrc" width="560" height="315" frameborder="0" webkitallowfullscreen mozallowfullscreen
            allowfullscreen width="100%" height="500px;" style="border: 0px;"></iframe> -->
          <video *ngIf="videoSection[0].uploaded_video !== '[]'" width="320" height="240" controls>
            <source [src]="getVideoLink()" >
            Your browser does not support the video tag.
          </video>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="row share-experince">
  <section id="ShareYourExperience-section" class="ShareYourExperience-section">
    <div class="container">

      <div class="content">

        <h1>{{'shareYourExper'|translate}}</h1>
        <h2>{{'shareYourExperQues'|translate}}
          <a [routerLink]="['/pages/ShareYourExperience']" routerLinkActive="router-link-active">
            {{'pressHere'|translate}}
          </a>
        </h2>

        <div id="animationContainer">
          <div class="infoGraphicStage">
            <div id="info_lines" class="elem lines" style="clip: rect(0px, 937px, 233px, 0px);">
              <img src="../../../assets/img/InfoGraphic-10.svg" alt="">
            </div>
            <div id="info_screen" class="elem screen" style="left: 350px; opacity: 0;">
              <img src="../../../assets/img/InfoGraphic-03.svg" alt="">
            </div>
            <div id="info_man" class="elem man" style="opacity: 0; transform: matrix(1, 0, 0, 1, 0, 0);">
              <img src="../../../assets/img/InfoGraphic-02.svg" alt="">
            </div>
            <div id="info_labtop" class="elem labtop" style="opacity: 0; transform: matrix(1, 0, 0, 1, 0, 0);">
              <img src="../../../assets/img/InfoGraphic-05.svg" alt="">
            </div>
            <div id="info_money" class="elem money" style="top: 50px; opacity: 0;">
              <img src="../../../assets/img/InfoGraphic-09.svg" alt="">
            </div>
            <div id="info_bug" class="elem bug" style="left: 870px; opacity: 0;">
              <img src="../../../assets/img/InfoGraphic-06.svg" alt="">
            </div>
            <div id="info_login" class="elem login" style="clip: rect(0px, 175px, 158px, 0px); opacity: 0;">
              <img src="../../../assets/img/InfoGraphic-07.svg" alt="">
            </div>
            <div id="info_circle" class="elem circle" style="height: 106px; width: 106px; opacity: 0;"></div>
            <div id="info_info2" class="elem info2"
              style="top: 154px; height: 127px; width: 138px; opacity: 0; transform: matrix3d(-1, 0, 0, 0, 0, 1, 0, 0, 0, 0, -1, 0, 0, 0, 0, 1);">
              <img src="../../../assets/img/InfoGraphic-04.svg" alt="">
            </div>
            <div id="info_info" class="elem info" style="right: 300px; opacity: 0;">
              <img src="../../../assets/img/InfoGraphic-08.svg" alt="">
            </div>
          </div>
        </div>
        <div class="nguCarouselStyle" *ngIf="experiments.length > 0">
          <ngu-carousel #myCarousel [inputs]="carouselOne" [dataSource]="newExperiments" style="width: 100%;">
            <div *nguCarouselDef="let item;let j = index" class="item">
              <div class="tile type-item">
                <!-- ar -->
                <div class="row" [ngStyle]="{'direction':currentLang == 'ar'  ? 'rtl' : 'ltr' }">
                  <div class="col-md-2 col-sm-4 col-12 carouselImg imgAr">
                    <img src="../../../assets/img/png-icon/icon-LogoIconp22.png" />
                  </div>
                  <div [ngStyle]="{'text-align':currentLang == 'ar'  ? 'right' : 'left' }"
                    class="col-md-10 col-sm-8 col-12 carouselInfo ">
                    <div class="title">
                      <p>{{currentLang == 'ar'? item.title : item.title_en}}</p>
                    </div>
                    <div id="moreExp" [innerHTML]="currentLang == 'ar' ? item.description : item.description_en"></div>
                  </div>
                </div>
                <!-- en -->
                <!-- <div *ngIf="currentLang==='en'" class="row">
                <div class="col-md-10 col-sm-8 col-6 carouselInfo infoEn">
                  <div class="title">
                    <p *ngIf="currentLang==='en'">{{item.title_en}}</p>
                  </div>
                  <div id="moreExp" [innerHTML]="currentLang == 'ar' ? item.description : item.description_en"></div>
                </div>
                <div class="col-md-2 col-sm-4 col-6 carouselImg imgEn">
                  <img src="../../../assets/img/png-icon/icon-LogoIconp22.png" />
                </div>
                
              </div> -->

              </div>
            </div>
            <button NguCarouselNext class="leftIn">
              <img src="../../../assets/img/png-icon/Forma-1-copy-5.png">
            </button>
            <button NguCarouselPrev class="rightIn">
              <img src="../../../assets/img/png-icon/Forma-1.png">
            </button>
          </ngu-carousel>
        </div>
        <!-- <div class="slider-ShareYourExperience slick-initialized slick-slider">
            <div aria-live="polite" class="slick-list draggable">
            <div class="slick-track" role="listbox"
              style="opacity: 1; width: 636px; transform: translate3d(0px, 0px, 0px);">
              <div class="ms-webpart-zone ms-fullWidth slick-slide slick-current slick-active" data-slick-index="0"
                aria-hidden="false" tabindex="-1" role="option" aria-describedby="slick-slide30" style="width: 636px;">
                <div id="MSOZoneCell_WebPartWPQ3"
                  class="s4-wpcell-plain ms-webpartzone-cell ms-webpart-cell-vertical ms-fullWidth ">
                  <div class="ms-webpart-chrome ms-webpart-chrome-vertical ms-webpart-chrome-fullWidth ">
                    <div webpartid="c3827edd-1d4e-4dd4-9d86-e44bdf916877" haspers="false" id="WebPartWPQ3" width="100%"
                      class="ms-WPBody noindex " allowdelete="false">
                      <div id="cbqwpctl00_ctl50_g_c3827edd_1d4e_4dd4_9d86_e44bdf916877" class="cbq-layout-main">
                      </div>
                      <div class="ms-clear"></div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div> -->
      </div>
    </div>
  </section>
</div>
<div class="row grand-footer">
  <div class="container">
    <div class="row lastRow">
      <div class="col-md-4 col-sm-6 col-12 important-links--section col-border ">
        <span class="title1"><span>{{currentLang == 'ar' ? 'روابط' : 'Important'}}</span> {{currentLang == 'ar' ? 'مهمة'
          : 'Links'}}
        </span>
        <ul class="important-links" style="width:100%">
          <li *ngFor="let link of importantLinks" class="link-item">
            <a *ngIf="currentLang==='ar'" class="link-item" [href]="link.link" target="_blank">
              {{link.title}}
            </a>
            <a *ngIf="currentLang==='en'" class="link-item" [href]="link.link" target="_blank">
              {{link.title_en}}
            </a>
          </li>
          <!-- <li class="link-item"><a class="ImportantLinks" href="https://cpa.org.sa/?page_id=48" title=""
              target="_blank">جمعية حماية المستهلك</a></li>
          <li class="link-item"><a class="ImportantLinks" href="http://eservices.mci.gov.sa/Eservices/balagh.htm"
              title="" target="_blank">وزارة
              التجارة
              والاستثمار</a></li>
          <li class="link-item"><a class="ImportantLinks"
              href="http://www.sama.gov.sa/ar-sa/ConsumerProtection/Pages/Complaint.aspx" title="" target="_blank">مؤسسة
              النقد العربي السعودي</a>
          </li>
          <li class="link-item"><a class="ImportantLinks"
              href="https://portalservices.citc.gov.sa/E-Services/Complaint/LandingScreen.aspx" title=""
              target="_blank">هيئة الاتصالات وتقنية
              المعلومات</a>
          </li> -->
        </ul>
      </div>
      <hr class="mainFooter-hr">
      <div class="col-md-4 col-sm-6 col-12 survey-section col-border">
        <span class="title1"><span>
            {{currentLang == 'ar' ? 'إستطلاع' : 'Survey'}}
          </span>
          {{currentLang == 'ar' ? 'رأي' : ''}}
        </span>

        <div class="financial-fraud-question">{{'financialFraudQues'|translate}}</div>
        <ng-container *ngIf="!(votedFlag || tempResultShow)">
          <form>
            <div class="custom-control custom-radio">
              <input type="radio" class="financial-fraud-question-inputs" value="1" [(ngModel)]="voteAnswer"
                name="financialFraudAnswer" id="financialFraudAnswer1">
              <label class="financial-fraud-question-inputs-label pl-1"
                for="financialFraudAnswer1">{{'yes'|translate}}</label>
            </div>

            <div class="custom-control custom-radio">
              <input type="radio" class="financial-fraud-question-inputs" value="0" [(ngModel)]="voteAnswer"
                name="financialFraudAnswer" id="financialFraudAnswer2">
              <label class="financial-fraud-question-inputs-label pl-1"
                for="financialFraudAnswer2">{{'no'|translate}}</label>
            </div>
          </form>

          <div class="wraper" style="display: block;">
            <a class="vote show" (click)="vote()">{{'vote'|translate}}</a>
            <span class="line"></span>
            <a class="result show" (click)="showResult()">{{'showTheResults'|translate}}</a>
          </div>
        </ng-container>
        <ng-container *ngIf="votedFlag || tempResultShow">
          <div id="Answers">
            <div class="row col-md-12 col-sm-12 col-12">
              <div class="resultDiv"><span id="span5">{{'yes'|translate}}</span><span id="precentID5">{{
                  voteResult.yes_persent }}%</span><span id="CountSpanID5">{{'voteNo'|translate}} {{ voteResult.yes
                  }}</span></div>
              <div id="containerDiv5" class="Container">
                <div id="internalDiv5" class="Internal" [ngStyle]="{'width.%': voteResult.yes_persent }"></div>
              </div>
            </div>
            <div class="row col-md-12 col-sm-12 col-xs-12">
              <div class="resultDiv"><span id="span6">{{'no'|translate}}</span><span id="precentID6">{{
                  voteResult.no_persent }}%</span><span id="CountSpanID6">{{'voteNo'|translate}} {{ voteResult.no
                  }}</span></div>
              <div id="containerDiv6" class="Container">
                <div id="internalDiv6" class="Internal" [ngStyle]="{'width.%': voteResult.no_persent }"></div>
              </div>
            </div>
            <div class="wraper" style="display: block;">
              <span id="AllCountSpanID6">{{'voteTotalNo'|translate}} {{voteResult.no_persent +
                voteResult.yes_persent}}</span>
              <a class="previous" *ngIf="tempResultShow" (click)="showResult()">{{'return'|translate}}</a>

            </div>
          </div>
        </ng-container>

      </div>
      <hr class="mainFooter-hr">
      <div class="col-md-4 col-sm-12 col-12 mail-list col-border">
        <span class="title1"><span>
            {{currentLang == 'ar' ? 'القائمة' : 'Email'}}
          </span>
          {{currentLang == 'ar' ? 'البريدية' : 'List'}}
        </span>

        <h3 class="mail-text">{{'subscribeToOurMailList'|translate}}</h3>
        <div class="col-md-12 padding-zero">

          <form #subscriptionForm="ngForm" (submit)="addSubscription(subscriptionForm)" style="direction: ltr;">
            <input type="email" class="mail-input form-control" name="email" placeholder="{{'email'|translate}}" ngModel
              required>
            <button class="subscribe-btn">{{'subscribe'|translate}}</button>
            <div [ngStyle]="{'text-align':currentLang == 'ar'  ? 'right' : 'left' }" *ngIf="state.message"
              class="alert alert-success" role="alert">
              {{currentLang == 'ar' ? state.message : state.message_en}}
            </div>

          </form>
        </div>
      </div>
    </div>
  </div>
</div>
<div class="disclamer" *ngIf="showDisclamerFlag == 'false'">
  <p id="text" [innerHTML]="currentLang == 'ar' ?  this.disclamer.text : this.disclamer.text_en"></p><button
    (click)="agree()">{{'agree'|translate}}</button>
</div>
<app-footer></app-footer>